module.exports = __webpack_public_path__ + "static/media/success_sfx.e9914d6b.mp3";